export default "__VITE_ASSET__7s_wc5F$__"